import {
  GET_PRODUCT_REQUEST,
  GET_RELATED_PRODUCTS_REQUEST,
  LIST_PRODUCTS_REQUEST
} from './constants';

export const listProducts = (slug, qString, page, onError) => ({
  type: LIST_PRODUCTS_REQUEST,
  slug,
  qString,
  page,
  onError
});

export const getProduct = (slug, onError) => ({
  type: GET_PRODUCT_REQUEST,
  slug,
  onError
});

export const getRelatedProducts = (productId, count, onError) => ({
  type: GET_RELATED_PRODUCTS_REQUEST,
  productId,
  count,
  onError
});
